module.exports = __webpack_public_path__ + "static/media/Hair_2.b3622cbc.svg";